var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "id": "outcome-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveDebt.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-2",
    attrs: {
      "id": "email-form",
      "data-name": "Email Form"
    }
  }, [_c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'credit_card_banka',
      "init-value": _vm.form.banka,
      "options": _vm.bankChoices,
      "normal": "",
      "name": 'Spoločnosť'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'banka');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Limit"
    }
  }, [_vm._v("Limit")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.limit,
      expression: "form.limit",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "name": "Limit",
      "data-name": "Limit",
      "placeholder": "",
      "id": "Limit",
      "required": ""
    },
    domProps: {
      "value": _vm.form.limit
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "limit", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.zostatok,
      expression: "form.zostatok",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "maxlength": "256",
      "name": "zostatok",
      "data-name": "zostatok",
      "id": "zostatok-3"
    },
    domProps: {
      "value": _vm.form.zostatok
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) return null;
        $event.preventDefault();
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zostatok", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "zostatok-3"
    }
  }, [_vm._v("Zostatok"), _c('strong')]);

}]

export { render, staticRenderFns }